import type { BadgeTone } from '@shared/ui';

import type { FlagLifecycle } from './flag';

/**
 * How a lifecycle renders.
 *
 * Its own module rather than a constant exported from a page, because a file
 * that exports both components and values loses Fast Refresh for everything in
 * it — editing a label would remount the flags table and drop whatever filter
 * the operator had typed.
 */

export const LIFECYCLE_LABEL: Record<FlagLifecycle, string> = {
    ga: 'GA',
    beta: 'Beta',
    dev: 'Dev',
    deprecated: 'Deprecated',
};

export const LIFECYCLE_TONE: Record<FlagLifecycle, BadgeTone> = {
    ga: 'ga',
    beta: 'beta',
    dev: 'dev',
    deprecated: 'deprecated',
};

/** Display order for the filter chips — maturity ascending, then retired. */
export const LIFECYCLE_ORDER: readonly FlagLifecycle[] = ['ga', 'beta', 'dev', 'deprecated'];
